import Vue from "vue";
import App from "./App.vue";

import "ant-design-vue/dist/antd.less";
import router from "./router";
import store from "./Store/store";
import VueCarousel from "vue-carousel";
import ApiService from "./services/api.service";
import { TokenService } from "./services/storage.service";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import {
  Select,
  Input,
  Button,
  Menu,
  Icon,
  Carousel,
  Row,
  Col,
  Drawer,
  Tabs,
  Form,
  Tooltip,
  Tag,
  Breadcrumb,
  List,
  Card,
  Table,
  Badge,
  Avatar,
  Dropdown,
  Upload,
  Modal,
  Affix,
  Popconfirm,
  message,
  notification,
  Alert,
  Radio,
  AutoComplete,
} from "ant-design-vue";

import {
  faPhone,
  faComment,
  faMedal,
  // faCartPlus,
  faSearchLocation,
  faCaretDown,
  faAngleRight,
  faBlog,
  faAt,
  faUser,
  faLocationArrow,
  faEnvelope,
  faLock,
  faAngleDown,
  faAngleUp,
} from "@fortawesome/free-solid-svg-icons";

// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faPhone,
  faComment,
  faMedal,
  // faCartPlus,
  faLocationArrow,
  faUser,
  faSearchLocation,
  faCaretDown,
  faAngleRight,
  faBlog,
  faAt,
  faEnvelope,
  faLock,
  faAngleDown,
  faAngleUp
);

import { library } from "@fortawesome/fontawesome-svg-core";
import { faCartPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
// import VueAnalytics from "vue-analytics";
import VueGtag from "vue-gtag";

import VueMatchHeights from "vue-match-heights";

import * as VueGoogleMaps from "vue2-google-maps";

library.add(faCartPlus);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueCarousel);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyD3UXM8LahqggpLcGBPh26tRJareI1Q0fw",
    libraries: "places", // necessary for places input
  },
});

// Vue.use(VueAnalytics, {
//   id: "UA-121822059-1",
//   router,
// });

Vue.use(
  VueGtag,
  {
    config: { id: "UA-121822059-1" },
  },
  router
);

Vue.use(Select);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(Carousel);
Vue.use(Row);
Vue.use(Col);
Vue.use(Drawer);
Vue.use(Tabs);
Vue.use(Form);
Vue.use(Input);
Vue.use(Button);
Vue.use(Tooltip);
Vue.use(Tag);
Vue.use(Breadcrumb);
Vue.use(List);
Vue.use(Card);
Vue.use(Table);
Vue.use(Badge);
Vue.use(Avatar);
Vue.use(Dropdown);
Vue.use(Upload);
Vue.use(Modal);
Vue.use(Affix);
Vue.use(Popconfirm);
Vue.use(Alert);
Vue.use(Radio);
Vue.use(AutoComplete);

Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;

Vue.use(VueMatchHeights, {
  disabled: [575],
});

Vue.config.productionTip = false;

ApiService.init(process.env.APP_ROOT_API);

// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader();
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
